import React from 'react'
import { ProxyWalletWithdrawModal } from './ProxyWalletWithdraw.Modal'
import { OrderModal } from './Order.Modal'
import { OrderSharingCard } from './OrderSharingCard.Modal'
import { OrderUpdateModal } from './OrderUpdate.Modal'
import { UserProfileModal } from './UserProfile.Modal'
import { FeesStructureModal } from './FeesStructure.Modal'
import { AssetInfoModal } from './AssetInfo.Modal'
import { SignInModal } from './SignIn.Modal'
import { SignUpModal } from './SignUp.Modal'
import { RoiCalculatorModal } from 'components/pages/gamesV3/Gameplay/InfiniteWinning/InfiniteLeaderboard/Modal/RoiCalculator.Modal'
import { OtherUserProfileModal } from './OtherUserProfile.Modal'
import { BidRulesModal } from './BidRules.Modal'
import { YolobotSignedUpModal } from './YoloBotSignedUp.Modal'

const MODAL_DICT = {
  signIn: <SignInModal />,
  signUp: <SignUpModal />,
  proxyWalletWithdraw: <ProxyWalletWithdrawModal />,
  roiCalculator: <RoiCalculatorModal />,
  order: <OrderModal />,
  orderSharingCard: <OrderSharingCard />,
  updateOrder: <OrderUpdateModal />,
  userProfile: <UserProfileModal />,
  feesStructure: <FeesStructureModal />,
  assetInfo: <AssetInfoModal />,
  otherUserProfile: <OtherUserProfileModal />,
  bidRules: <BidRulesModal />,
  yolobotSignedUp: <YolobotSignedUpModal />,
}

export const ModalLib = ({ modalId, ...modalProps }) => {
  const selectedModal = MODAL_DICT[modalId] || null
  const composedModal = selectedModal && React.cloneElement(selectedModal, { ...modalProps })

  return composedModal
}
